import {
  COMPLIANCE_CADENCE_LABELS,
  COMPLIANCE_LOG_OUTCOME_LABELS,
  COMPLIANCE_RECORD_STATUS_LABELS,
  type ComplianceCadence,
  type ComplianceLogOutcome,
  type ComplianceRecordStatus,
} from '@sitewise/shared';
import { ComplianceBadge, type ComplianceTone } from '@sitewise/ui';

export function StatusBadge({
  status,
  tone,
}: {
  status: ComplianceRecordStatus;
  tone: ComplianceTone;
}) {
  return (
    <ComplianceBadge tone={tone} withDot>
      {COMPLIANCE_RECORD_STATUS_LABELS[status]}
    </ComplianceBadge>
  );
}

export function cadenceLabel(
  cadence: ComplianceCadence | null,
  customDays?: number | null,
): string {
  if (!cadence) return '—';
  if (cadence === 'custom') {
    return customDays ? `Every ${customDays} days` : 'Custom';
  }
  return COMPLIANCE_CADENCE_LABELS[cadence];
}

export function outcomeLabel(o: ComplianceLogOutcome): string {
  return COMPLIANCE_LOG_OUTCOME_LABELS[o];
}

export function formatDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString();
}

export function formatRelativeDays(iso: string): string {
  const ms = new Date(iso).getTime() - Date.now();
  const days = Math.round(ms / (24 * 60 * 60 * 1000));
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days === -1) return 'yesterday';
  if (days > 0) return `in ${days}d`;
  return `${Math.abs(days)}d ago`;
}
